module.exports = __webpack_public_path__ + "img/IMG_20191125_200423.8ea4597f.jpg";